module.exports = __webpack_public_path__ + "img/banner-1-en.ee9eed56.png";